import React from 'react';
import "./Modal.css";
import  { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom';
import Form from "./Form";
import userEvent from '@testing-library/user-event';
class Modal extends Component{
    
    componentWillUnmount() {
            if(this.refs.shipping.checked)
                this.props.substractShipping()
    }
    handleChecked = (e)=>{
        if(e.target.checked){
            this.props.addShipping();
        }
        else{
            this.props.substractShipping();
        }
    }
    UserPrompt(){
        
        alert("Your order was placed. Thanks for choosing us!")
            
        
    }
    
    render(){ 
        
    return (
        <div className="modal">
            <div className="modal-content">
                <div className="modal-header">
                    <h4 className="modal-title">Total Bill:</h4><Link to="/Cart" ><button>X</button></Link>
                </div>
                <div className="modal-body">
                <div className="collection">
                <li className="collection-item"><b>Your Total:{this.props.total} $</b></li>
                    <li className="collection-item">
                            <label>
                                <input type="checkbox" ref="shipping" onChange= {this.handleChecked} />
                                <span>Shipping(+6$)</span><br/><br/>
                                <li>Enter The Shipping Details: </li>
                                <Form/>
                                <li className="notice">(Once done click confirm & then Place order)</li>
                            </label>
                        </li>
                       
                        
                    </div>
                </div>
                <div className="modal-footer">
                    <Link  to="/Items" ><button onClick={this.UserPrompt} className="button">Place order</button></Link>
                </div>
            </div>
            
        </div>
    )
    } }
    const mapStateToProps = (state)=>{
        return{
            addedItems: state.addedItems,
            total: state.total
        }
    }
    
    const mapDispatchToProps = (dispatch)=>{
        return{
            addShipping: ()=>{dispatch({type: 'ADD_SHIPPING'})},
            substractShipping: ()=>{dispatch({type: 'SUB_SHIPPING'})}
        }
    }
    
    export default connect(mapStateToProps,mapDispatchToProps)(Modal)

